import { template as template_b54da2864c114693a6e1765d3066d8f8 } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import FreestyleGuide from 'ember-freestyle/components/freestyle-guide';
import FreestyleSection from 'ember-freestyle/components/freestyle-section';
import { pageTitle } from 'ember-page-title';
import { provide } from 'ember-provide-consume-context';
import RouteTemplate from 'ember-route-template';
import { GetCardContextName, GetCardsContextName, GetCardCollectionContextName } from '@cardstack/runtime-common';
import AiAssistantApplyButtonUsage from '@cardstack/host/components/ai-assistant/apply-button/usage';
import AiAssistantAttachmentPickerUsage from '@cardstack/host/components/ai-assistant/attachment-picker/usage';
import AiAssistantChatInputUsage from '@cardstack/host/components/ai-assistant/chat-input/usage';
import AiAssistantFocusPillUsage from '@cardstack/host/components/ai-assistant/focus-pill/usage';
import AiAssistantMessageUsage from '@cardstack/host/components/ai-assistant/message/usage';
import AiAssistantSkillMenuUsage from '@cardstack/host/components/ai-assistant/skill-menu/usage';
import CardCatalogModal from '@cardstack/host/components/card-catalog/modal';
import PillMenuUsage from '@cardstack/host/components/pill-menu/usage';
import SearchSheetUsage from '@cardstack/host/components/search-sheet/usage';
import { getCardCollection } from '@cardstack/host/resources/card-collection';
import { getCard } from '@cardstack/host/resources/card-resource';
import formatComponentName from '../helpers/format-component-name';
import type StoreService from '../services/store';
import type { ComponentLike } from '@glint/template';
interface UsageComponent {
    title: string;
    component: ComponentLike;
}
interface HostFreestyleSignature {
    Args: {
    };
}
class HostFreestyleComponent extends Component<HostFreestyleSignature> {
    @service
    private store: StoreService;
    formatComponentName = formatComponentName;
    @provide(GetCardContextName)
    private get getCard() {
        return getCard;
    }
    @provide(GetCardsContextName)
    private get getCards() {
        return this.store.getSearchResource.bind(this.store);
    }
    @provide(GetCardCollectionContextName)
    private get getCardCollection() {
        return getCardCollection;
    }
    get usageComponents() {
        return [
            [
                'AiAssistant::ApplyButton',
                AiAssistantApplyButtonUsage
            ],
            [
                'AiAssistant::CardPicker',
                AiAssistantAttachmentPickerUsage
            ],
            [
                'AiAssistant::ChatInput',
                AiAssistantChatInputUsage
            ],
            [
                'AiAssistant::FocusPill',
                AiAssistantFocusPillUsage
            ],
            [
                'AiAssistant::Message',
                AiAssistantMessageUsage
            ],
            [
                'AiAssistant::PillMenu',
                PillMenuUsage
            ],
            [
                'AiAssistant::SkillMenu',
                AiAssistantSkillMenuUsage
            ],
            [
                'SearchSheet',
                SearchSheetUsage
            ]
        ].map(([name, c])=>{
            return {
                title: name,
                component: c
            };
        }) as UsageComponent[];
    }
    static{
        template_b54da2864c114693a6e1765d3066d8f8(`
    {{pageTitle 'Host Components'}}

    <h1 class='boxel-sr-only'>Boxel Host Components Documentation</h1>

    <FreestyleGuide
      @title='Boxel Host Components'
      @subtitle='Living Component Documentation'
    >
      <FreestyleSection
        @name='Components'
        class='freestyle-components-section'
        as |Section|
      >
        {{#each this.usageComponents as |c|}}
          <Section.subsection @name={{this.formatComponentName c.title}}>
            <c.component />
          </Section.subsection>
        {{/each}}
      </FreestyleSection>
    </FreestyleGuide>

    <CardCatalogModal />
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default RouteTemplate(HostFreestyleComponent);
